import { render } from "./PaiementKKiaPayPage.vue?vue&type=template&id=0059b15f&ts=true"
import script from "./PaiementKKiaPayPage.vue?vue&type=script&lang=ts"
export * from "./PaiementKKiaPayPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__